"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./Footer.scss");
var _GlobalFooter = _interopRequireDefault(require("./GlobalFooter"));
var _SectorFooter = _interopRequireDefault(require("./SectorFooter"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Footer = _ref => {
  let {
    logo,
    globalFooterText,
    globalFooterEnabled,
    sectorFooterLinks,
    socialLinksTitle,
    socialLinks,
    legalStuff,
    calloutLinks,
    Link,
    contentfulId
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("footer", {
    className: "ter-footer"
  }, /*#__PURE__*/_react.default.createElement(_SectorFooter.default, {
    sectorFooterLinks: sectorFooterLinks,
    socialLinksTitle: socialLinksTitle,
    socialLinks: socialLinks,
    calloutLinks: calloutLinks,
    Link: Link,
    contentfulId: contentfulId
  }), globalFooterEnabled === true ? /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-footer__grid-wrapper-bottom"
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "ter-footer__global-footer"
  }, /*#__PURE__*/_react.default.createElement(_GlobalFooter.default, {
    logo: logo,
    globalFooterText: globalFooterText,
    legalStuff: legalStuff
  }))) : null);
};
var _default = Footer;
exports.default = _default;